import React from "react";
import styled from "styled-components";
import Button from "./Button";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
	gap: 1rem;
`;

const Image = styled.img`
	width: 500px;
	height: 400px;
`;

const ImageDownloader = ({ imageUrl }) => {
	const handleDownload = () => {
		const link = document.createElement("a");
		link.href = imageUrl;
		link.target = "_blank";
		link.download = imageUrl;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<Container>
			<Image src={imageUrl} alt="Downloadable content" />
			<Button onClick={handleDownload}>Download</Button>
		</Container>
	);
};

export default ImageDownloader;
